module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    },
    slot: "left"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/back.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  }), _vm._v(" "), _c('span', {
    staticClass: "jump-back"
  }, [_vm._v("返回")])]), _vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n    "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n      " + _vm._s(_vm.userName) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "list-part"
  }, _vm._l((_vm.tabList), function(item) {
    return _c('div', {
      staticClass: "msg-items"
    }, [_c('p', {
      staticClass: "item-date"
    }, [_c('span', [_vm._v(_vm._s(item.createDate))])]), _vm._v(" "), _c('div', {
      staticClass: "item-detail"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: 'detail',
          query: {
            id: item.taskId,
            stepId: item.stepId,
            flowId: item.flowId,
            tag: '',
            title: item.flowName
          }
        }
      }
    }, [_c('p', {
      staticClass: "item-detail-type"
    }, [_vm._v(_vm._s(item.flowName))]), _vm._v(" "), _c('p', {
      staticClass: "item-detail-subtitle"
    }, [_vm._v("您有一个申请需要处理，请点击本信息进行处理")]), _vm._v(" "), _c('p', {
      staticClass: "item-detail-title"
    }, [_vm._v("标题：" + _vm._s(item.businessName))]), _vm._v(" "), _c('p', {
      staticClass: "item-detail-user"
    }, [_vm._v("申请人：" + _vm._s(item.operatorName))])])], 1)])
  })), _vm._v(" "), _c('tabbar', [_c('tabbar-item', {
    attrs: {
      "link": "/todo"
    },
    on: {
      "on-item-click": _vm.todoTrigger
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("待办事宜")])]), _vm._v(" "), _c('tabbar-item', {
    on: {
      "on-item-click": _vm.launchTrigger
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("发起申请")])]), _vm._v(" "), _c('tabbar-item', {
    on: {
      "on-item-click": _vm.processTrack
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("进度跟踪")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maskStatus),
      expression: "maskStatus"
    }],
    staticClass: "done-dialog"
  }, [_c('span', {
    staticClass: "done-list-item",
    on: {
      "click": _vm.goDone
    }
  }, [_vm._v("已办事项")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/arrow-down.png")
    },
    slot: "label"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maskStatus),
      expression: "maskStatus"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.processTrack
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1831536d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Ecms.vue
// module id = t1ST
// module chunks = 0